import { onAuthStateChanged } from "firebase/auth";

import { auth } from "~/lib/firebase";
import { logger } from "~/services/logger";

import { authActions } from "./actions";
import { authStore } from "./store";

/**
 * Bridge Firebase Auth → POS auth store, logout direction only.
 *
 * Firebase sign-in is wired at the `authActions.login()` call site (PWEB-89),
 * not here. This listener exists so that when a Firebase session is invalidated
 * — token revoked, signed out in another tab, user disabled — we drop POS to
 * `status: "none"` and force a re-login.
 *
 * * TO-DO: [PWEB-99] Refactor this once legacy auth is gone
 * Interim guard: when Firebase reports no user but POS still has a legacy
 * `token` in the store, we leave the session alone. This is to cover cashiers
 * signed in via the legacy flow only — the initial `onAuthStateChanged(null)`
 * fire on every page load would otherwise log them out.
 */
export function startFirebaseAuthSync(): () => void {
  return onAuthStateChanged(auth, (user) => {
    if (user) return;

    const state = authStore.getState();
    if (state.status === "none") return;
    if (state.token !== null) return;

    logger.trace("[AUTH] Firebase user signed out — logging out POS");
    authActions.logout();
  });
}
